<template>
  <el-dropdown trigger="click" @command="handleSetEnviro" class='lu-click right-menu-icon'>
    <div>
      <svg-icon class-name="right-menu-icon" icon-class="list"/>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for='(env, idx) in inEnvList' :key='env.value' :disabled="env.label===inSelectedEnv.name" :command="idx">{{ env.label }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import messageHandler from '@/mixins/message'

export default {
  mixins: [ messageHandler ],
  computed: {
    ...mapGetters( [ 'envList', 'selectedEnv', 'tangoConfig' ] ),
    inSelectedEnv() {
      return this.selectedEnv
    },
    inEnvList: function () {
      let arr = []
      this.envList.map(env => {
        arr.push({
          label: env.name,
          value: arr.length
        })
      })
      return arr
    }
  },
  methods: {
    handleSetEnviro(idx) {
      this.$store.dispatch('tangoEnv/setTangoEnv', idx)
      this.$store.dispatch('tangoEnv/close', this)
        .then(() => this.loadConfigTango())
        .then(() => {
          this.$message({
            message: 'Switch Tango Environment Success',
            type: 'success'
          })
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
    }
  }
}
</script>



